import {
  booleanSchema,
  dispatchLicenseNumberSchema as dlnSchema,
  emailSchema,
  frequencyCodeSchema as fSchema,
  invoiceSchema as iSchema,
  memoSchema as mSchema,
  numberSchema,
  phoneNumberSchema,
  postCodeSchema as pcSchema,
  stringSchema,
  tagCodeSchema as tcSchema,
  urlSchema
} from 'schema/validator'
import * as z from 'zod'

export const nameSchema = stringSchema(20)
export const specialtySchema = stringSchema(20)
export const specialtyIndustrySchema = stringSchema(20)
export const postCodeSchema = pcSchema
export const addressSchema = stringSchema(100)
export const homePhoneSchema = phoneNumberSchema
export const homepageSchema = urlSchema
export const establishmentSchema = z.string()
export const invoiceSchema = iSchema
export const salesValueSchema = numberSchema
export const properValueSchema = numberSchema
export const bpValueSchema = numberSchema
export const deliverAddressSchema = emailSchema
export const dispatchLicenseSchema = booleanSchema
export const dispatchLicenseNumberSchema = dlnSchema
export const pMarkSchema = booleanSchema
export const ismsSchema = booleanSchema
export const memoSchema = mSchema
export const frequencyCodeSchema = fSchema
export const tagCodeSchema = tcSchema
export const focusCustomerSchema = z.boolean()
